import { HttpEvent, HttpHeaders, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ConfigurationService } from '@smals/ngx-configuration-service';
import { mergeMap, Observable, take } from 'rxjs';
import { HTTP_HEADERS } from 'vidis-common';
import { selectUserIsProfessional } from '../store/selectors/user.selector';

export const apiInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<unknown>> => {
  const store = inject(Store);
  const configService = inject(ConfigurationService);
  const apiUrl = configService.getEnvironmentVariable('apiUrl');

  if (req.url.startsWith('http') || req.url.includes('assets/')) {
    return next(req);
  };

  const headers = req.headers || new HttpHeaders();
  return store.select(selectUserIsProfessional).pipe(
    take(1),
    mergeMap(isProfessional => next(req.clone({
      url: `${apiUrl}${req.url}`,
      headers: headers
        .set('user-type', HTTP_HEADERS.getUserType({isProfessional}))
        .set('client-type', HTTP_HEADERS.clientType.webApp),
    })))
  );
};
